// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2022-11-25 18:04:26 +0100 (Fri, 25 Nov 2022) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 130869 $
// Purpose     : parts for managing types
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {useApi, useSelector, useState, usePersistent, usePhysicalNode, useMemo} from 'uix/hooks'
import {HeaderSegment, XMenu, DebugFeature} from 'uix/components'
import {SearchableJSONTree} from 'uix/chunks'
import {Sel} from 'uix/registries'

// ---Local imports
import {TypesConfigTable, DatatypeConfigTable, TypeCaption} from './components'
import {useFullTypeConfig} from './hooks'
// ---Exports

export const TypesConfig = ({}) => {
  let [debug, setDebug] = useState(false)
  let {id} = useSelector(Sel.request)
  let [query, setQuery] = usePersistent('typesCfgQuery', '')
  let [hideEmptyCounts, setHideEmptyCounts] = usePersistent('hideEmptyCounts', false)

  let {typescfg: data, loading} = useFullTypeConfig()
  // s2wp~byType~letter
  //~ let typeName = id?.split('~').slice(-1)[0]
  let datatypeName = 'metadata'
  let content = null

  if (!loading) {
    if (debug) {
      //~ let dbgData = data?.metadata[typeName] || data?.metadata || ''
      content = <SearchableJSONTree hideRoot data={data} query={query} />
    } else {
      content = (
        <TypesConfigTable
          query={query}
          datatypeName={datatypeName}
          xdtypes={data}
          withCounts
          hideEmptyCounts={hideEmptyCounts}
        />
      )
    }
  }
  //~ }
  let menu = (
    <XMenu>
      <XMenu.Input
        icon="search"
        onEnterKey={setQuery}
        debounce={1000}
        defaultValue={query}
        onValueChange={value => setQuery(value)}
        title="query config value like 'pdf' or 'mets'"
      />
      <XMenu.Toggle
        icon="circle outline"
        title="hide types with count=0"
        set={setHideEmptyCounts}
        value={hideEmptyCounts}
      />
      <DebugFeature>
        <XMenu.Toggle icon="bug" set={setDebug} value={debug} />
      </DebugFeature>
    </XMenu>
  )
  return (
    <HeaderSegment
      major
      header="Types"
      subheader={datatypeName}
      icon="configure"
      menu={menu}
      loading={loading}
      overflowInner
      flexInner
      flex
    >
      {content}
    </HeaderSegment>
  )
}

export const TypeConfig = ({i18n}) => {
  let {typescfg, loading} = useFullTypeConfig()
  let node = usePhysicalNode()
  let type_name = node.type
  let dtcfg = typescfg?.[node.datatypeName]?.[type_name]

  let request = useSelector(Sel.request)

  if (node.datatypeName == 'domain') {
    type_name = request.id.split('~').slice(-1)[0]
    dtcfg = typescfg?.['metadata']?.[type_name]
  }

  return (
    <HeaderSegment
      major
      header="Konfiguration"
      subheader={
        <TypeCaption
          width={12}
          name={type_name}
          caption={`${i18n.getType(type_name)} (${type_name})`}
        />
      }
      icon="configure"
      menu={null}
      loading={loading}
    >
      <DatatypeConfigTable dtcfg={dtcfg} />
    </HeaderSegment>
  )
}
